<template>
    <div class="block zzs" id="zzs">
        <div class="itemTitBox wow animated bounceInRight">
            <p class="big">赞助商</p>
            <p class="small">SPONSORS</p>
        </div>
        <div class="dhxq wow animated bounceInLeft">
            <div class="dhxqItem_zzs wow animated fadeInUp">
                <!-- <div class="triangle_icon">
                    <img src="../assets/images/triangle_icon.png" alt="" />
                </div> -->
                <ul>
                    <li
                        v-for="(item, index) in dataJson.sponsor_list"
                        :key="index"
                    >
                        <img class="img_data" :src="item" />
                    </li>
                </ul>
            </div>
        </div>
        <img class="bgImg" src="../assets/images/471x463.png" />
    </div>
</template>
<script>
import dataJson from "../assets/index.json";
export default {
    data() {
        return {
            dataJson,
        };
    },
};
</script>
<style>
@media (max-width: 900px) {
  #zzs ul li  {
    width: 260px !important;
  }
  #zzs .bgImg  {
    width: 763px !important;
    height: 750px !important;
  }
}
</style>
<style lang="less" scoped>
@import url("../views/index.less");
#zzs {
    position: relative;
    margin-top: 34px;
    .bgImg {
        width: 471px;
        height: 463px;
        position: absolute;
        left: 0;
        bottom: -140px;
    }
    .dhxq {
        position: relative;
        z-index: 2;
        box-sizing: border-box;
        // padding: 0 35px;
        padding: 0 120px;
        margin: 0 auto;
        margin-top: 27px;
        width: 779px;
        // height: 439px;
        // background: url("../../static/images/zzs/783x269.png") no-repeat;
        background: url("../assets/images/1558x877.png") no-repeat;
        background-size: 100% 100%;
        .dhxqItem_zzs {
            display: flex;
            width: 100%;
            transition: all 0.6s;
            padding-top: 41px;
            padding-bottom: 39px;
            ul {
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                li {
                    // float: left;
                    // margin-right: 13px;
                    margin-bottom: 12px;
                    width: 166px;
                    transition: all 0.6s;
                    position: relative;
                    z-index: 10;
                    img {
                        width: 100%;
                    }
                }
                li:hover {
                    transform: scale(1.1);
                    z-index: 99;
                }
            }
            // &:hover {
            //     transform: scale(1.05);
            // }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/zzs.vue